export default "__VITE_ASSET__CBKcQfP9__"